<script lang="ts">
import { page } from '$app/stores';
import { createGetEnvironmentQuery } from '$lib/api/environment';
import { useCreateOrg, useOrgsContext } from '$lib/api/orgs';
import { useAuthContext } from '$lib/auth';
import { navigate } from '$lib/navigate';

import { getChangeOrgRedirect, getCreateOrgRedirect } from './get-org-redirect';
import NavBar from './nav-bar.svelte';
import OrgMenu from './org-menu.svelte';
import { getPages } from './pages';
import Login from './user-menu.svelte';

export let validOrg = true;
/** When set, overrides whether the org switcher is shown. Defaults to validOrg. */
export let showOrgMenu: boolean | undefined = undefined;

const { authState, login, logout } = useAuthContext();
const { organizations, setCurrentOrg } = useOrgsContext();
const createOrg = useCreateOrg();

const envQuery = createGetEnvironmentQuery();

const setOrgAndRedirect = (
  nextOrgID: string | undefined,
  redirectPath: string | undefined
) => {
  if (nextOrgID) {
    setCurrentOrg(nextOrgID);
  }
  if (redirectPath) {
    void navigate(redirectPath);
  }
};

const onChangeOrg = (nextOrgID: string) => {
  setOrgAndRedirect(
    nextOrgID,
    getChangeOrgRedirect(nextOrgID, $page.url.pathname)
  );
};

const onCreateOrg = (name: string, onSuccess: () => void) => {
  $createOrg(
    { name },
    {
      onSuccess: (response) => {
        const nextOrgID = response.organization?.id;
        setOrgAndRedirect(nextOrgID, getCreateOrgRedirect(nextOrgID));
        onSuccess();
      },
    }
  );
};

$: pages = getPages({
  currentPathname: $page.url.pathname,
  authStatus: $authState.status,
});

$: enableInkeep = $envQuery.data?.enableInkeep ?? false;
$: shouldShowOrgMenu = showOrgMenu ?? validOrg;
</script>

<NavBar
  {...pages}
  pageLinks={validOrg ? pages.pageLinks : []}
  authState={$authState}
  {enableInkeep}
>
  {#if shouldShowOrgMenu}
    <OrgMenu
      {onChangeOrg}
      {onCreateOrg}
      currentOrg={$organizations.current}
      recentOrgs={$organizations.recent}
      allOrgs={$organizations.all}
    />
  {/if}
  <Login
    {login}
    {logout}
    authState={$authState}
  />
</NavBar>
